import React from 'react'
import {connect} from 'react-redux'
import Component from '../components/contact'
import actions from '../actions/help'

class Container extends React.Component {

  static displayName = 'Contact.container'

  render() {
    return <Component {...this.props} />
  }
}


const mapStateToProps = state => {
  const data = state.ui.help.help
  return {
    loading: data.get('loadingContact'),
    name: data.get('name'),
    email: data.get('email'),
    blockEmailField: data.get('defaultEmail') !== '',
    message: data.get('message'),
    showContactSuccessMessage: data.get('showContactSuccessMessage'),
    error: data.get('error'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    sendContactMessage: () => dispatch(actions.sendContactMessage()),
    setName: (name) => dispatch(actions.setName(name)),
    setEmail: (email) => dispatch(actions.setEmail(email)),
    setMessage: (message) => dispatch(actions.setMessage(message)),
    setShowContactSuccessMessage: (show) => dispatch(actions.setShowContactSuccessMessage(show)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/help/containers/contact.js